<div class="container">
  <div class="modal" tabindex="-1" role="dialog" id="errorDialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="fs-4 fw-bold text-danger">{{message}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-3">
    <h2 class="ml-2 mr-2 col-sm-8 text-center mb-4 bg-warning rounded">Paiement frais de reinscription</h2>
  </div>

  @if (levels.length<=0) { <form (ngSubmit)="findSubscriptionSubscriptionInfo()" [formGroup]="studentForm">

    <div class="row justify-content-center">
      <div class="col-sm-6 form-group form-floating mb-3">
        <input type="text" class="form-control mt-2" formControlName="idStudent" id="idStudent" />
        <label for="idStudent">Entrer code compta de l'élève</label>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-3 d-grid gap-2">
        <button type="submit" class="btn btn-primary rounded" [disabled]="!studentForm.valid">
          <i class="fa fa-search"></i> Chercher
        </button>
      </div>
    </div>
    </form>
    }

    @if (levels.length>0) {
    <form (ngSubmit)="onSubscription()" [formGroup]="payForm">
      @if (reliquat) {
      <div class="row justify-content-center">
        <div class="col-sm-10 mb-2 text-center"><strong>Nom de l'élève :</strong> {{reliquat!!.studentName}}</div>
        <div class="col-sm-10 mb-2 text-center"><strong>Nom du tuteur :</strong> {{reliquat!!.parentFirstName}}
          {{reliquat!!.parentLastName}}</div>
        <div class="col-sm-10 mb-2 text-center"><strong>Code compta de l'elève :</strong> {{reliquat!!.idStudent}}
        </div>
      </div>
      }
      <div class="row justify-content-center">
        <div class="col-sm-6 form-group form-floating mb-4">
          <select class="form-select mt-2" id="idLevel" (change)="onChangeLevel()" formControlName="idLevel">
            <option selected value="">Choisir le cycle</option>
            @for (lev of levels; track lev) {
            <option value="{{lev.id}}">{{lev.level}}</option>
            }
          </select>
          <label for="idLevel">Choisir le cycle</label>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-6 form-group form-floating mb-4">
          <select class="form-select mt-2" id="idClass" (change)="onChangeClass()" formControlName="idClass">
            <option selected value="">Choisir la classe</option>
            @for (cls of selectedClasses; track cls) {
            <option value="{{cls.classe.id}}">{{cls.classe.libelle}} {{cls.classe.serie}}</option>
            }
          </select>
          <label for="idClass">Choisir la classe</label>
        </div>
      </div>
      @if (currentClass!=undefined) {
      <div class="row justify-content-center">
        @if (nonRequiredItems.length>0) {
        <p class="col-sm-10 text-center text-success fs-4">Services complémentaires</p>
        }
      </div>
      }
      @for (item of nonRequiredItems; track item) {
      <div class="row justify-content-center">
        <div class="col-sm-6 form-check">
          <input class="form-check-input" type="checkbox" (change)="onChangeItem($event,item)">
          <label class="form-check-label">{{item.libelle}} : {{item.value}}</label>
        </div>
      </div>
      }
      @if (currentClass) {
      <div class="row justify-content-center">
        <div class="col-sm-6 form-group form-floating mb-4">
          <div class="form-check form-switch">
            <input class="form-check-input bg-checked-success" role="switch" type="checkbox"
              (change)="onTransportChange()">
            <label class="form-check-label">Abonnement transport</label>
          </div>
        </div>
      </div>
      }
      @if (currentClass&&transportSubsScription) {
      <div class="row justify-content-center">
        <div class="col-sm-6 form-floating mb-4">
          <select class="form-select mt-2" id="idTransport" (change)="onSelectTransport()"
            formControlName="idTransport">
            @for (tr of transports; track tr) {
            <option value="{{tr.id}}">{{tr.itinerary}}</option>
            }
          </select>
          <label for="idTransport">Choisir votre itinéraire</label>
        </div>
      </div>
      }
      <div class="row justify-content-center mb-4">
        <div class="col-sm-10">
          @if (reliquat!=undefined) {
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title text-center">Détails frais réinscription</h5>
              @if (reliquat.id!!>0) {
              <div class="form-check">
                <input class="form-check-input bg-success" type="checkbox" checked disabled>
                <label class="form-check-label"> Reliquat : {{reliquat.amount}}</label>
              </div>
              }
              @if (currentClass!=undefined) {
              <div>
                <ul class="list-unstyled">
                  <li>
                    <div class="form-check">
                      <input class="form-check-input bg-success" type="checkbox" checked disabled>
                      <label class="form-check-label">Cycle: {{currentClass.classe.libelle}}
                        {{currentClass.classe.serie}}</label>
                      <div class="w-90">
                        <div class="ml-4">Frais généraux : <strong>{{currentClass.yearlyFee}}</strong></div>
                        @if (currentClass.firstMonthAmount>0) {
                        <div>Mois d'Octobre :
                          <strong>{{currentClass.firstMonthAmount}}</strong>
                        </div>
                        }
                        @if (currentClass.apecAmount>0) {
                        <div>APEC : <strong>{{currentClass.apecAmount}}</strong></div>
                        }
                        @if (requiredItems.length>0) {
                        <div>
                          @for (item of requiredItems; track item) {
                          <div> {{item.libelle}}: {{item.value}}</div>
                          }
                        </div>
                        }
                        @if (selectedItems.length>0) {
                        <div>@for (item of selectedItems; track item) {
                          <div> {{item.libelle}}: {{item.value}}</div>
                          }
                        </div>
                        }
                      </div>
                    </div>
                  </li>
                </ul>
                @if (currentTransport!=undefined) {
                <div>
                  <div class="form-check">
                    <input class="form-check-input bg-success" type="checkbox" checked disabled>
                    <label class="form-check-label">Transport :{{currentTransport.itinerary}}</label>
                    <div>Inscription :{{currentTransport.subscription}}</div>
                    <div>Mensualité :{{currentTransport.monthlyAmount}}</div>
                  </div>
                </div>
                }
                @if (currentIdTransport==0) {
                <div class="form-check">
                  <input class="form-check-input bg-danger" type="checkbox" checked disabled>
                  <label class="form-check-label">Transport : non inscrit</label>
                </div>
                }
                <div class="row justify-content-center">
                  <div class="col-sm-7 d-flex justify-content-center">
                    <button class="mt-2 btn btn-danger rounded fw-bold" type="button" disabled>Total :
                      {{totalAmount}}</button>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-5 d-flex justify-content-center">
          <button type="button" class="btn btn-danger fw-bold mx-2" (click)="returnToSearch()">Retour</button>
          <button type="submit" class="btn btn-success fw-bold mx-2" [disabled]="!payForm.valid">Valider</button>
        </div>
      </div>
    </form>
    }

    <div class="modal" tabindex="-1" role="dialog" id="payDialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          @if (reliquat!=undefined) {
          <div class="card h-100">
            <div class="card-body w-90">
              <h5 class="card-title text-center">Détails frais réinscription</h5>
              @if (reliquat.id!!>0) {
              <div class="form-check">
                <input class="form-check-input bg-success" type="checkbox" checked disabled>
                <label class="form-check-label"> Reliquat : {{reliquat.amount}}</label>
              </div>
              }
              @if (currentClass!=undefined) {
              <div>
                <ul class="list-unstyled">
                  <li>
                    <div class="form-check">
                      <input class="form-check-input bg-success" type="checkbox" checked disabled>
                      <label class="form-check-label">Classe: {{currentClass.classe.libelle}}
                        {{currentClass.classe.serie}}</label>
                      <div class="ml-4">Frais généraux annuels : <strong>{{currentClass.yearlyFee}}</strong></div>
                      @if (currentClass.firstMonthAmount>0) {
                      <div>Mois d'Octobre :
                        <strong>{{currentClass.firstMonthAmount}}</strong>
                      </div>
                      }
                      @if (currentClass.apecAmount>0) {
                      <div>APEC : <strong>{{currentClass.apecAmount}}</strong></div>
                      }
                      @for (item of requiredItems; track item) {
                      <div> {{item.libelle}}: {{item.value}}</div>
                      }
                      @for (item of selectedItems; track item) {
                      <div> {{item.libelle}}: {{item.value}}</div>
                      }
                    </div>
                  </li>
                </ul>
              </div>
              }
              @if (currentTransport!=undefined) {
              <div>
                <div class="form-check">
                  <input class="form-check-input bg-success" type="checkbox" checked disabled>
                  <label class="form-check-label">Transport :{{currentTransport.itinerary}}</label>
                  <div>Inscription :{{currentTransport.subscription}}</div>
                  <div>Mensualité :{{currentTransport.monthlyAmount}}</div>
                </div>
              </div>
              }
              <div class="row">
                <div class="fs-3">Montant reinscription : <span class="fw-bold">{{totalAmount}}</span></div>
              </div>
              <div class="row">
                @if (fees>0) {
                <div class="fs-3">Frais de service : <span class="fw-bold">{{fees}}</span></div>
                }
              </div>
            </div>
          </div>
          }
          <form [formGroup]="phoneForm">
            <div class="card-body">
              <div class="row justify-content-center">
                <div class="col-sm-8">
                  <p>Veuillez choisir votre moyen de paiement</p>
                </div>
              </div>
              <div class="row justify-content-center gap-method">
                <!--div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2"
                style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('omsn')">
                <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money"
                  width="50">
                <p class="mt-1 ml-3">Orange money</p>
              </div>
              <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
                data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('wvsn')">
                <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
                <p class="mt-1 ml-3">Wave</p>
              </div-->
                @for(p of paymentMeans; track $index) {
                <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
                  [attr.data-method]="p.code" style="width: auto;" (click)="onSelectPaymentMethod(p)">
                  <img class="mt-4 img-fluid justify-content-center" src="{{p.logo}}" alt="{{p.label}}" width="50">
                  <p class="mt-1  ml-3">{{p.label}}</p>
                </div>
                }
              </div>
              <div class="row justify-content-center">
                @if (paymentNetwork?.isMobileMoney) {
                <div class="col-sm-6 form-group form-floating mb-3">
                  <input type="text" class="form-control mt-2" formControlName="phone" id="phone" />
                  <label for="phone">Numéro téléphone</label>
                </div>
                }
              </div>
            </div>
            <div class="modal-footer row justify-content-center align-items-center">
              @if(!processing){
              <div class="col-6 d-flex justify-content-center">
                <button class="btn btn-success mx-2" data-bs-dismiss="modal" type="submit" (click)="onPaySubscription()" [disabled]="phoneForm.invalid">Payer</button>
                <button class="btn btn-danger mx-2" data-bs-dismiss="modal"
                  (click)="onCancelSubscription()">Annuler</button>
              </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
</div>